import { Skeleton } from '@/components/ui/skeleton';

const loadingItems = Array(16).fill(1);

const ListItemSkeleton = () => {
  return (
    <div className="w-full py-2">
      <div className="flex items-center gap-2">
        <Skeleton className="size-8 rounded-md" />
        <Skeleton className="h-3.5 rounded-md grow" />
      </div>
    </div>
  );
};

const ListLoader = () => {
  return (
    <div className="[&>*:not(:last-child)]:border-b mt-1.5 flex flex-col items-center">
      {loadingItems.map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ListItemSkeleton key={index} />
      ))}
    </div>
  );
};

export default ListLoader;
